import * as yup from "yup";
import { AIAgentAnalyticsItemDto } from "./AIAgentAnalyticsItemDto";
import { AIAgentAnalyticsItemModel } from "./AIAgentAnalyticsItemModel";

const MISSING_COUNTRY_VALUES = ["n/a", "", "unknown"];

const CHANNEL_ID_TO_NAME_DICT: Record<string, string> = {
  whatsapp: "WhatsApp",
  instagram: "Instagram",
  chatbot: "Web Chat",
  twilio: "SMS (Text) Chat",
  email: "Email Chat",
  voice: "Phone Calls",
};

const analyticsItemSchema = yup.object({
  businessImpact: yup.string().required(),
  channel: yup.string().required(),
  country: yup.string().nullable(),
  humanHandoverRequired: yup.boolean().required(),
  sentiment: yup.string().required(),
  topic: yup.string().required(),
  subtopic: yup.string().required(),
});

const normalizeCountry = (value: string | null): string | null => {
  if (value === null) {
    return null;
  }

  const normalized = value.trim().toLowerCase();

  const isMissing = MISSING_COUNTRY_VALUES.some(
    (sentinel) => normalized === sentinel.toLowerCase()
  );

  if (isMissing) {
    return null;
  }

  return normalized;
};

const humanizeLabel = (label: string) =>
  label
    .trim()
    .replace(/_/g, " ")
    .replace(/\b\w/g, (char) => char.toUpperCase());

export const transformAIAgentAnalyticsItemDtoToModel = (
  dto: AIAgentAnalyticsItemDto
): AIAgentAnalyticsItemModel | null => {
  try {
    const input = {
      businessImpact: humanizeLabel(dto.business_impact_type),
      channel:
        CHANNEL_ID_TO_NAME_DICT[dto.channel.trim().toLowerCase()] ??
        dto.channel,
      country: normalizeCountry(dto.country),
      humanHandoverRequired: dto.human_handover_required,
      sentiment: humanizeLabel(dto.sentiment),
      topic: humanizeLabel(dto.topic),
      subtopic: humanizeLabel(dto.sub_topic),
    };

    const validated = analyticsItemSchema.validateSync(input);

    return validated as AIAgentAnalyticsItemModel;
  } catch {
    return null;
  }
};

export const transformAIAgentAnalyticsItemsDtoToModels = (
  dtos: AIAgentAnalyticsItemDto[]
): AIAgentAnalyticsItemModel[] => {
  return dtos.reduce<AIAgentAnalyticsItemModel[]>((acc, dto) => {
    const model = transformAIAgentAnalyticsItemDtoToModel(dto);

    if (model) {
      acc.push(model);
    }

    return acc;
  }, []);
};
